import React from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';

// Renders a page's existing desktop <Table> node unchanged at sm+; on xs,
// renders a stacked list built from renderCard(row, idx) instead. Extracted
// from the isMobile ? <Cards/> : <Table/> pattern already used in ViewMarks.js
// so every list page can share one wrapper instead of hand-rolling it.
export default function ResponsiveDataView({ rows, renderCard, table, keyExtractor, footer }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (!isMobile) return table;

  return (
    <Box>
      {rows.map((row, idx) => (
        <Box key={keyExtractor ? keyExtractor(row, idx) : (row.id ?? idx)}>
          {renderCard(row, idx)}
        </Box>
      ))}
      {footer}
    </Box>
  );
}
